<template>
  <div v-if="showBanner && active && !isOpeningGuidedCamera" ref="banner" class="bp-down-banner fs-14 text-center d-flex align-items-center justify-content-center font-weight-regular">
    <div class="banner-content">
      {{ bannerText }}
    </div>
    <img @click="closeBanner" class="close-icon cursor-pointer" src="@/assets/images/icons/ic_close_banner.svg" alt="close">
  </div>
</template>

<script>
import { mapState } from "vuex";
import systemConfigService from '@/services/system-config';
export default {
  name: 'BPDownBanner',
  data() {
    return {
      dismissed: false,
      bannerText: '',
      active: false,
    };
  },
  computed: {
    ...mapState({
      locid: (state) => state.authenticateSeller.locid,
      isOpeningGuidedCamera: (state) => state.photo.isOpeningGuidedCamera,
    }),
    showBanner() {
      if (this.dismissed) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.getSystemConfig();
  },
  beforeDestroy() {
    document.body.style.paddingTop = null;
  },
  methods: {
    closeBanner() {
      this.dismissed = true;
    },
    async getSystemConfig() {
      try {
        const params = {};
        if (this.locid) {
          params.locid = this.locid;
        }
        const result = await systemConfigService.getSystemConfig(params);
        this.$store.dispatch('setSystemConfigurations', result.data);
        if (result.status === 200 && result.data.bpDownBanner) {
          this.bannerText = result.data.bpDownBanner.bannerText;
          this.active = result.data.bpDownBanner.active;
        }
      } catch (error) {
        console.error("Error get system config:", error);
      }
    },
  },
}
</script>

<style lang="scss">
.bp-down-banner {
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  min-height: 40px;
  background-color: black;
  color: white;
  z-index: 9999;
  padding: 0 15px;
  
  .banner-content {
    max-width: 90%;
  }

  .close-icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

@media screen and(max-width: 768px) {
  .bp-down-banner {
    min-height: 80px;
    .banner-content {
      white-space: normal;
      overflow: visible;
      text-overflow: unset;
      max-width: 80%;
    }

    .close-icon {
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    }
  }
}

</style> 